import {LayoutModel} from '../models/layout.model'

interface Props {
  campa: LayoutModel
  total?: number
  available?: number
  mods?:any
}

const LayoutProgressBar = ({campa, mods}: Props) => {
  let disponiblidad = 0
  if (campa.TotalCamas) {
    disponiblidad = parseInt(String((campa.TotalCamasDIS * 100) / campa.TotalCamas))
  }


  const getStatus = mods?.find(item=>item.Id === campa.ModuloId)
  return (
    <>
      <div className='d-flex align-items-center w-200px w-sm-300px flex-column mt-3'>
        <div className='d-flex justify-content-between w-100 mt-auto mb-2'>
          <span className='fw-bold fs-6 text-gray-500'>{getStatus && getStatus.EstadoModulo_descripcion ==='BLOQUEADO' ? 'Bloqueado':'Disponible'}</span>
          <span className='fw-bolder fs-6'>{disponiblidad}%</span>
        </div>
        <div className='h-5px mx-3 w-100 bg-light mb-3'>
          <div
            className='bg-success rounded h-5px'
            role='progressbar'
            style={{width: disponiblidad + '%'}}
          ></div>
        </div>
      </div>
    </>
  )
}

export {LayoutProgressBar}
